import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { TableBlockAttsInterface } from '~/types/AppData/Blocks/TableBlockInterface';

export default component$(({ data }: TableBlockAttsInterface): JSX.Element => {
  const [headerRow, ...rows] = data;

  return (
    <div class='overflow-auto max-w-[90vw]'>
      <table class='border-collapse text-left w-full'>
        <thead>
          <tr>
            {headerRow.map((cell, index) => {
              if (!cell) return null;
              return (
                <th
                  class='bg-lightGrey py-3 px-10 my-0 mx-auto'
                  key={index}
                  dangerouslySetInnerHTML={cell}
                />
              );
            })}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex} class='border-b-[1px] border-b-lightGrey'>
              {row.map((cell, index) => {
                if (!cell) return null;
                return (
                  <td
                    dangerouslySetInnerHTML={cell}
                    key={index}
                    class='py-3 px-10 my-0 mx-auto'
                  />
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});
